module.exports = __webpack_public_path__ + "img/null.1d0e93fa.jpg";